import { formatDateHuman } from "../date-utils";
import { dossierExpiringDescription } from "../misc/dossier-expiring-description";
export const dossierDtoFields = [{
        name: "protocol",
        title: "Protocollo",
        render: (record) => record.dossier.protocol
    }, {
        name: "customerName",
        title: "Cliente"
    }, {
        name: "dossierTypeDescription",
        title: "Causale Pratica"
    }, {
        name: "startDate",
        title: "Data inizio",
        render: (record) => formatDateHuman(record.dossier.startDate)
    }, {
        name: "title",
        title: "Descrizione aggiuntiva",
        render: (record) => record.dossier.title
    }, {
        name: "statusDescription",
        title: "Stato"
        // }, {
        //   name: "startYear",
        //   title: "Anno Inizio",
        //   titleClass: "has-text-centered",
        //   dataClass: "has-text-centered",
        //   render: (record: IDossierDTO) => record.dossier.startYear
    }, {
        name: "endYear",
        title: "Anno Fine",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.dossier.endYear != null ? record.dossier.endYear : ''
    }, {
        name: "deadlineDate",
        title: "Scadenza",
        render: (record) => {
            let formattedDate = formatDateHuman(record.dossier.deadlineDate);
            if (record.finalStatus == 0) {
                return dossierExpiringDescription(record.dossier, formattedDate);
            }
            return formattedDate;
        }
    }];
